import { promotions, trustBadges } from '@/mocks/sports';

export default function PromotionsSection() {
  return (
    <section id="promotions" className="w-full px-4 md:px-6 py-14 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            限时优惠活动
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            注册即享多重福利，bb体育为您带来超值体育竞技娱乐体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5 mb-14">
          {promotions.map((promo) => (
            <div
              key={promo.id}
              className="bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6 hover:border-accent-300 transition-all duration-300"
            >
              <div className="flex items-start justify-between mb-3">
                <div className="w-10 h-10 rounded-xl bg-accent-100 flex items-center justify-center">
                  <i className={`${promo.icon} text-accent-600 text-lg`}></i>
                </div>
                <span className="px-2.5 py-1 rounded-md bg-primary-100 text-primary-700 text-xs font-label font-semibold">
                  {promo.tag}
                </span>
              </div>
              <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-950 mb-2">
                {promo.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {promo.description}
              </p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {trustBadges.map((badge, idx) => (
            <div key={idx} className="flex items-center gap-3 p-4 bg-background-50 border border-background-200/70 rounded-xl">
              <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                <i className={`${badge.icon} text-accent-600 text-lg`}></i>
              </div>
              <div>
                <p className="text-sm font-label font-semibold text-foreground-950">{badge.title}</p>
                <p className="text-xs text-foreground-500">{badge.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}